// extracted by mini-css-extract-plugin
module.exports = {"page-home":"home_page-home__pMqJD","title":"home_title__Jxpcx"};